module.exports = __webpack_public_path__ + "media/images/icon/ico_question-ccab248f22cd06dcc271a8f5f357419c.svg";